module.exports = __webpack_public_path__ + "static/media/icon-login-report-not-active.42af00c4.svg";